import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel, Checkbox } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Referral_cashback_add } from "../../../../store/actions/SuperAdminActions/SuperAdminReferralCashbackAction";
import moment from "moment";
import {
  InputBoxComponent,
  NewInputText,
  TextAreaReusableComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import SimpleReactLightbox from "simple-react-lightbox";
import MultipleImageUploadComponent from "../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";

function AddDunzoPartners(props) {
  let history = useHistory();

  const [ShowTab, setShowTab] = useState("1");
  const handleShowTab = (e) => setShowTab(e);

  const onSuccessAddOffer = () => {
    // setLoading(false);
    history.push("/superadmindunzoDeliverySettings");
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24-700">
                  {ShowTab == 1 ? (
                    <>Add New Service Provider </>
                  ) : ShowTab == 2 ? (
                    <> Business KYC and License Information</>
                  ) : ShowTab == 3 ? (
                    <> Setup Bank Account for Payout</>
                  ) : (
                    <> Setup Payment terms</>
                  )}
                </div>
              </div>
              <hr />
              {ShowTab == 1 && (
                <Form>
                  <Row className="pt-4">
                    <Col lg={5} className="my-2">
                      <Form.Group>
                        <TextField
                          // ref={nameee}
                          id="referral_name"
                          label="Add Delivery Partner Name"
                          type="text"
                          // onChange={(e) =>
                          //   formik.setFieldValue("referral_name", e.target.value)
                          // }
                          // value={formik.values.referral_name}
                          variant="outlined"
                          className="w-100"
                          name="name"
                        />
                      </Form.Group>
                      <FormControl variant="outlined" fullWidth>
                        <InputLabel id="demo-simple-select-outlined-label">
                          Assign cities
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-outlined-label"
                          id="demo-simple-select-outlined"
                          name="referral_type"
                          // onChange={(e) =>
                          //   formik.setFieldValue("referral_type", e.target.value)
                          // }
                          // value={formik.values.referral_type}
                          label="referral_type"
                        >
                          <MenuItem
                            value="Referral Program Name"
                            disabled
                            selected
                          >
                            Select cities
                          </MenuItem>
                          <MenuItem value="0">Hyderabad</MenuItem>
                          <MenuItem value="1">Pune</MenuItem>
                        </Select>
                      </FormControl>
                    </Col>
                    <Col lg={12}>
                      <hr />
                      <div className="font_20_b py-4">
                        Maintain Delivery Charges
                      </div>
                      <div>
                        <span className="f12-500">Distance upto 5km</span>
                        <p className="f12-400 opacity5">
                          Up to 5 km, charges will be split between merchant and
                          user half and half
                        </p>
                        <Row className="py-4 align-items-center">
                          <Col md={3}>
                            <TextField
                              id="start_time"
                              label="For Merchant"
                              variant="outlined"
                              type="text"
                              className="w-100"
                              //   onChange={formik.handleChange}
                              //   value={formik.values.start_time}
                              name="start_time"
                            />
                          </Col>
                          <Col md={3}>
                            <TextField
                              id=""
                              label="For Users"
                              variant="outlined"
                              type="text"
                              className="w-100"
                              //   onChange={formik.handleChange}
                              //   value={formik.values.start_time}
                              name="start_time"
                            />
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <span className="f12-500">Distance above 5km</span>
                        <p className="f12-400 opacity5">
                          Up to 5 km, charges will be split between merchant and
                          user half and half
                        </p>
                        <Row className="py-4 align-items-center">
                          <Col md={3}>
                            <TextField
                              id="start_time"
                              label="For Merchant"
                              variant="outlined"
                              type="text"
                              className="w-100"
                              //   onChange={formik.handleChange}
                              //   value={formik.values.start_time}
                              name="start_time"
                            />
                          </Col>
                          <Col md={3}>
                            <TextField
                              id=""
                              label="For Users"
                              variant="outlined"
                              type="text"
                              className="w-100"
                              //   onChange={formik.handleChange}
                              //   value={formik.values.start_time}
                              name="start_time"
                            />
                          </Col>
                        </Row>
                      </div>
                      <div>
                        <span className="f12-500" style={{ color: "#2196F3" }}>
                          Add Business KYC and License Information{" "}
                          <Checkbox Checked color="success" />
                        </span>{" "}
                        <br />
                      </div>
                      <div>
                        <span className="f12-500" style={{ color: "#2196F3" }}>
                          Setup Bank Account for Payout{" "}
                          <Checkbox Checked color="success" />
                        </span>
                      </div>
                      <div className="py-4 d-flex align-items-center">
                        <Button
                          variant="outline-secondary"
                          className="btn-lg mr-4 px-5 btn150px"
                          onClick={() => onSuccessAddOffer()}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-lg px-5 btn150px"
                          //type="submit"
                          onClick={(e) => handleShowTab("2")}
                        >
                          Next
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              )}
              {ShowTab == 2 && (
                <Form>
                  <div className="col-6">
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        displayLabel={true}
                        controlId="name"
                        labelText="Name of the Company"
                        variant="outlined"
                        // showLabelSmall={true}
                        // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                        placeHolder="eg. Amealio"
                        name="name"
                        inputType="text"
                        //   onChange={this.onChange}
                        //   value={this.state.name}
                        //   disabled={editButton === false ? true : false}
                        required="required"
                        //   onFocusOut={this.onFocusOut}
                        //   showBottom={true}
                        //   helpTextDisplay={true}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        *Max 50 Character
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        displayLabel={true}
                        controlId="name"
                        labelText="Doing Business As"
                        variant="outlined"
                        // showLabelSmall={true}
                        // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                        placeHolder="eg. Amealio"
                        name="name"
                        inputType="text"
                        //   onChange={this.onChange}
                        //   value={this.state.name}
                        //   disabled={editButton === false ? true : false}
                        required="required"
                        //   onFocusOut={this.onFocusOut}
                        //   showBottom={true}
                        //   helpTextDisplay={true}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        *Max 50 Character
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        controlId="address"
                        displayText={true}
                        labelText="Business Address"
                        multiline={true}
                        labelTextClass="text-area-lable"
                        placeholder="Business Address"
                        rows="4"
                        //   onChange={this.onChange}
                        //   onFocusOut={this.onFocusOut}
                        name="address"
                        //   value={this.state.address}
                        //   disabled={editButton === false ? true : false}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        (Business Address on Amealio need to be written to help
                        users navigate to the place, please include all the
                        details )
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <div className="row">
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            displayLabel={true}
                            controlId="area"
                            labelText="Area*"
                            placeHolder="eg. Koregaon Park*"
                            name="area"
                            inputType="text"
                            //   onChange={this.onChange}
                            //   onFocusOut={this.onFocusOut}
                            //   onKeyDown={InputCharacterCheck}
                            //   value={this.state.area}
                            //   disabled={editButton === false ? true : false}
                            required="required"
                            showBottom={true}
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            displayLabel={true}
                            controlId="city"
                            labelText="City*"
                            placeHolder="eg. Pune*"
                            name="city"
                            inputType="text"
                            required="required"
                            showBottom={true}
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            displayLabel={true}
                            controlId="pinCode"
                            labelText="Pin/Zip Code*"
                            placeHolder="eg. 404040*"
                            name="pinCode"
                            inputType="text"
                            maxLength="10"
                            // onKeyDown={InputNumberFunc}
                            required="required"
                            showBottom={true}
                          />
                        </div>
                        <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                          <NewInputText
                            displayLabel={true}
                            extraClass="mb-4"
                            controlId="businessState"
                            labelText="State*"
                            placeHolder="eg. Pune*"
                            name="businessState"
                            inputType="text"
                            //   onChange={this.onChange}
                            //   onFocusOut={this.onFocusOut}
                            //   onKeyDown={InputCharacterCheck}
                            //   value={this.state.businessState}
                            //   disabled={editButton === false ? true : false}
                            required="required"
                            showBottom={true}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        displayLabel={true}
                        controlId="name"
                        labelText="GST Number"
                        variant="outlined"
                        // showLabelSmall={true}
                        // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                        placeHolder="eg. Amealio"
                        name="name"
                        inputType="number"
                        //   onChange={this.onChange}
                        //   value={this.state.name}
                        //   disabled={editButton === false ? true : false}
                        required="required"
                        //   onFocusOut={this.onFocusOut}
                        //   showBottom={true}
                        //   helpTextDisplay={true}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        *Max 50 Character
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        displayLabel={true}
                        controlId="name"
                        labelText="FSSAI Code"
                        variant="outlined"
                        // showLabelSmall={true}
                        // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                        placeHolder="eg. Amealio"
                        name="name"
                        inputType="text"
                        //   onChange={this.onChange}
                        //   value={this.state.name}
                        //   disabled={editButton === false ? true : false}
                        required="required"
                        //   onFocusOut={this.onFocusOut}
                        //   showBottom={true}
                        //   helpTextDisplay={true}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        *14 Character Code
                      </div>
                    </div>
                    <p className="mb-2">Or</p>
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        displayLabel={true}
                        controlId="name"
                        labelText="FSSAI Date of Application"
                        variant="outlined"
                        // showLabelSmall={true}
                        // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                        placeHolder="eg. Amealio"
                        name="name"
                        inputType="date"
                        //   onChange={this.onChange}
                        //   value={this.state.name}
                        //   disabled={editButton === false ? true : false}
                        required="required"
                        //   onFocusOut={this.onFocusOut}
                        //   showBottom={true}
                        //   helpTextDisplay={true}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        (If you don't have FSSAI code and you have applied for
                        FSSAI, you can give the date of application here)
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        displayLabel={true}
                        controlId="name"
                        labelText="PAN/ Tax Number"
                        variant="outlined"
                        // showLabelSmall={true}
                        // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                        placeHolder="PAN/ Tax Number"
                        name="name"
                        inputType="text"
                        //   onChange={this.onChange}
                        //   value={this.state.name}
                        //   disabled={editButton === false ? true : false}
                        required="required"
                        //   onFocusOut={this.onFocusOut}
                        //   showBottom={true}
                        //   helpTextDisplay={true}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        10-character code
                      </div>
                    </div>
                    <div className="col-12 p-0">
                      <NewInputText
                        extraClass="m-0"
                        displayLabel={true}
                        controlId="name"
                        labelText="TAN Number"
                        variant="outlined"
                        // showLabelSmall={true}
                        // helperTextBottom="(Restaurant names on Amealio need to be written as they appear on the board outside the restaurant)"
                        placeHolder="TAN Number"
                        name="name"
                        inputType="text"
                        //   onChange={this.onChange}
                        //   value={this.state.name}
                        //   disabled={editButton === false ? true : false}
                        required="required"
                        //   onFocusOut={this.onFocusOut}
                        //   showBottom={true}
                        //   helpTextDisplay={true}
                      />
                      <div
                        className="opacity5 mt-1 mb-4"
                        style={{
                          fontSize: "12px",
                          fontFamily: "Roboto-Regular",
                          color: "#212121",
                          lineHeight: "16px",
                        }}
                      >
                        10-character code
                      </div>
                    </div>
                    <div>
                      <SimpleReactLightbox>
                        <MultipleImageUploadComponent
                          title="Upload Documents"
                          smallTitle="(Upload supporting documents for PAN, GST, FSSAI and other business documents as applicable MoU)"
                          //stateValue={bank_informaion}
                          accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                          // loader={state.bankImageLoader}
                        />
                      </SimpleReactLightbox>
                    </div>
                    <div
                      className="opacity5 mt-1 mb-4"
                      style={{
                        fontSize: "12px",
                        fontFamily: "Roboto-Regular",
                        color: "#212121",
                        lineHeight: "16px",
                      }}
                    >
                      You may receive a call for KYC and Confirmation
                    </div>
                    <div className="py-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 btn150px"
                        onClick={(e) => handleShowTab("1")}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5 btn150px"
                        //type="submit"
                        onClick={(e) => handleShowTab("3")}
                      >
                        Next
                      </Button>
                    </div>
                  </div>
                </Form>
              )}
              {ShowTab == 3 && (
                <div className="bank_and_other_details_onboarding_main">
                  <div className="d-flex justify-content-between">
                    <div className="f16-700 mt-4">Bank Account Info</div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-8 p-0">
                    <NewInputText
                      controlClass={"bankName"}
                      inputType="text"
                      helpTextDisplay={true}
                      helperTextBottom="Enter Name on the Account"
                      // onKeyDown={InputCharNumSpaceFunc}
                      maxLength={120}
                      labelText="Name on Bank Account"
                      name="bankName"
                      // onChange={formik.handleChange}
                      // value={formik.values.bankName}
                      // onFocusOut={formik.handleBlur}
                      // isInvalid={
                      //   formik.errors.bankName && formik.touched.bankName
                      // }
                    />
                    <NewInputText
                      controlClass={"email"}
                      extraClass={`mb-1 mt-4`}
                      inputType="text"
                      labelText="Email"
                      helpTextDisplay={true}
                      helperTextBottom="Email"
                      name="email"
                      // onChange={formik.handleChange}
                      // value={formik.values.email}
                      // onFocusOut={formik.handleBlur}
                      // isInvalid={
                      //   formik.errors.account_number &&
                      //   formik.touched.account_number
                      // }
                    />
                  </div>
                  <div className="f16-700 mt-4 mb-2">Account Type?</div>
                  <div className="checkbox-main-div">
                    <div className="checkbox-bank-account justify-content-start">
                      <label className="enRadioWithText mr-3 f18-500">
                        Current Account
                        <input
                          type="radio"
                          name="account_type"
                          //   value={
                          //     localizationText.length > 0
                          //       ? country[localizationText]
                          //           .accountTypeOneCurrent
                          //       : null
                          //   }
                          //   onChange={formik.handleChange}
                          //   checked={
                          //     formik.values.account_type ===
                          //     country[localizationText]
                          //       .accountTypeOneCurrent
                          //   }
                        />
                        <span className="checkmark"></span>
                      </label>
                      <label className="enRadioWithText f18-500">
                        Savings Account
                        <input
                          type="radio"
                          name="account_type"
                          //   value={
                          //     localizationText.length > 0
                          //       ? country[localizationText]
                          //           .accountTypeTwoSaving
                          //       : null
                          //   }
                          //   onChange={formik.handleChange}
                          //   checked={
                          //     formik.values.account_type ===
                          //     country[localizationText]
                          //       .accountTypeTwoSaving
                          //   }
                        />
                        <span className="checkmark"></span>
                      </label>
                    </div>
                  </div>
                  <div className="col-6">
                    <NewInputText
                      controlClass={"account_number"}
                      extraClass={`mb-1 mt-4`}
                      inputType="text"
                      //   onInput={maxLengthCheck}
                      maxLength={20}
                      //   onKeyDown={InputNumberFunc}
                      labelText="Account Number"
                      name="account_number"
                      //   onChange={formik.handleChange}
                      //   value={formik.values.account_number}
                      //   onFocusOut={formik.handleBlur}
                    />

                    <div className="f11-400 opacity5">
                      Account Number (6 Digits to Max 20 digits)
                    </div>
                    <NewInputText
                      controlClass={"re_account_number"}
                      extraClass={`mb-1 mt-4`}
                      inputType="text"
                      maxLength={20}
                      //   onKeyDown={InputNumberFunc}
                      labelText="Re-Enter Account Number"
                      name="re_account_number"
                      //   onChange={formik.handleChange}
                      //   value={formik.values.re_account_number}
                      //   onFocusOut={formik.handleBlur}
                      // isInvalid={
                      //   formik.errors.account_number &&
                      //   formik.touched.account_number
                      // }
                    />
                    <div className="f11-400 opacity5">
                      Account Number (6 Digits to Max 20 digits)
                    </div>
                    <NewInputText
                      controlClass={"account_ifsc"}
                      extraClass={`mb-1 mt-4`}
                      inputType="text"
                      //   onKeyDown={InputCharNumFunc}
                      maxLength={11}
                      labelText="IFSC Code"
                      helpTextDisplay={true}
                      helperTextBottom="IFSC Code (11-Character Code)"
                      name="account_ifsc"
                      //   onChange={formik.handleChange}
                      //   value={formik.values.account_ifsc}
                      //   onFocusOut={formik.handleBlur}
                      // isInvalid={
                      //   formik.errors.account_ifsc && formik.touched.account_ifsc
                      // }
                    />
                    <NewInputText
                      controlClass={"account_branch"}
                      extraClass={`mb-1 mt-4`}
                      name="branchName"
                      inputType="text"
                      //   onKeyDown={InputCharacterCheck}
                      maxLength={35}
                      labelText="Branch Name"
                      helpTextDisplay={true}
                      helperTextBottom="Branch Name"
                      //   onChange={formik.handleChange}
                      //   value={formik.values.account_branch}
                      //   onFocusOut={formik.handleBlur}
                      // isInvalid={
                      //   formik.errors.account_branch && formik.touched.account_branch
                      // }
                    />
                  </div>
                  <div className="col-12 bank-error-message-spacing p-0 mb-3">
                    <SimpleReactLightbox>
                      <MultipleImageUploadComponent
                        title="Upload Relevant Documents"
                        smallTitle="(Upload supporting documents such as a Cancelled Cheque, Bank Statement as applicable) - You may receive a call for KYC and Confirmation"
                        // loader={state.bankImageLoader}
                        accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                      />
                    </SimpleReactLightbox>
                  </div>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={(e) => handleShowTab("2")}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      //type="submit"
                      onClick={(e) => handleShowTab("4")}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
              {ShowTab == 4 && (
                <div>
                  <div className="py-4 d-flex align-items-center">
                    <Button
                      variant="outline-secondary"
                      className="btn-lg mr-4 px-5 btn150px"
                      onClick={(e) => handleShowTab("3")}
                    >
                      Cancel
                    </Button>
                    <Button
                      variant="danger"
                      className="btn-lg px-5 btn150px"
                      //type="submit"
                      onClick={(e) => handleShowTab("4")}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
export default AddDunzoPartners;

// AddDunzoPartners.propTypes = {
//   auth: PropTypes.object.isRequired,
//   Referral_cashback_add: PropTypes.func.isRequired,
// };

// const mapStateToProps = (state) => ({
//   auth: state.auth,
// });

// export default connect(mapStateToProps, {
//   Referral_cashback_add,
// })(AddDunzoPartners);
